module.exports = __webpack_public_path__ + "img/invite_code.06903c3d.png";